import { action, computed, observable, makeObservable } from 'mobx';

export class ErrorService {
  private error: object = {};

  constructor() {
    makeObservable<ErrorService, "error">(this, {
      error: observable,
      setError: action,
      cleanUpErrors: action,
      getErrors: computed,
      notContainErrors: computed
    });
  }

  public setError(path: string | null, error?: string | null) {
    if (path) {
      this.error[path] = error;
    } else {
      this.cleanUpErrors();
    }
  }

  public cleanUpErrors() {
    this.error = observable.object({});
  }

  public get getErrors(): object {
    return this.error;
  }

  public get notContainErrors(): boolean {
    const keys = Object.keys(this.error);
    let containErrors = true;
    keys.forEach((key) => {
      if (this.error[key] !== null) {
        containErrors = false;
      }
    });
    return containErrors;
  }
}
